// Shared chat attachment plumbing — used by the worker and staff composers.
// Files upload to the same object-storage infrastructure as submissions; serving is
// authorized per conversation server-side (/chat/files/{attachmentId}).
import axios from "axios";
import { API, authHeaders } from "@/constants/roles";

export const CHAT_ACCEPT = ".png,.jpg,.jpeg,.webp,.gif,.mp4,.mov,.webm,.pdf,.txt,.md,.csv,.json,.zip,.blend,.psd,.aep";

export const chatFileUrl = (id) => `${API}/chat/files/${id}?auth=${encodeURIComponent(localStorage.getItem("melto_token") || "")}`;

export const attachmentKind = (ct) =>
  (ct || "").startsWith("image/") ? "image" : (ct || "").startsWith("video/") ? "video" : "file";

export const fmtFileSize = (bytes) => {
  if (bytes == null) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const uploadChatFile = (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API}/chat/attachments`, form, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
  }).then((r) => r.data);
};
